"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const StepIndicatorSegment_1 = __importDefault(require("./StepIndicatorSegment/StepIndicatorSegment"));
const StepIndicatorComponent = ({ centered, children, counters, current, labels = true }) => {
    const originalSteps = (0, uswds_react_utils_1.flattenChildren)(react_1.Children.toArray(children));
    const totalSteps = originalSteps.length;
    const currentStep = originalSteps[current - 1];
    const heading = (0, react_1.isValidElement)(currentStep)
        ? currentStep.props.children
        : undefined;
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-step-indicator', centered && 'usa-step-indicator--center', !labels && 'usa-step-indicator--no-labels', counters &&
            `usa-step-indicator--counters${counters === 'small' ? '-sm' : ''}`), "aria-label": "progress", children: [(0, jsx_runtime_1.jsx)("ol", { className: "usa-step-indicator__segments", children: originalSteps.map((child, index) => {
                    const el = child;
                    if ((0, react_1.isValidElement)(el)) {
                        return (0, react_1.cloneElement)(el, {
                            complete: index + 1 < current,
                            current: index + 1 === current
                        });
                    }
                    return el;
                }) }), (0, jsx_runtime_1.jsx)("div", { className: "usa-step-indicator__header", children: (0, jsx_runtime_1.jsxs)("h2", { className: "usa-step-indicator__heading", children: [(0, jsx_runtime_1.jsxs)("span", { className: "usa-step-indicator__heading-counter", children: [(0, jsx_runtime_1.jsx)("span", { className: "usa-sr-only", children: "Step" }), (0, jsx_runtime_1.jsx)("span", { className: "usa-step-indicator__current-step", children: current }), ' ', (0, jsx_runtime_1.jsxs)("span", { className: "usa-step-indicator__total-steps", children: ["of ", totalSteps] })] }), (0, jsx_runtime_1.jsx)("span", { className: "usa-step-indicator__heading-text", children: heading })] }) })] }));
};
const StepIndicator = Object.assign(StepIndicatorComponent, { Segment: StepIndicatorSegment_1.default });
exports.default = StepIndicator;
